module.exports = {"320602001":"城东街道","320602002":"和平桥街道","320602003":"任港街道","320602004":"新城桥街道","320602005":"虹桥街道","320602006":"学田街道","320602007":"钟秀街道","320602008":"文峰街道","320602009":"观音山街道","320602010":"狼山镇街道","320602400":"南通崇川经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320602.json
// module id = 809
// module chunks = 0